import { methodEditQuestion } from "api/apiquestion/api";
import { QuestionEditKind } from "model/question/data/edit";
import {
    methodCheckIssueResult,
    methodJudgeIssue,
    methodUpdateQuestion,
} from "../../api/apiexam/api";
import { UpdateQuestionTags } from "../../api/Question";
import { AlertSuccess } from "../../component/basic/feedbacks/snackbar/Snackbar";
import { ExamResult } from "../../model/exam/result/Result";
import { QuestionCategory } from "../../model/question/data/category";
import {
    Analysis,
    Answer,
    InputMethod,
    InquiryData,
    ManualMark,
    PassageData,
    QuestionData,
    QuestionEditExtraData,
} from "../../model/question/data/data";
import { QuestionState } from "../../model/question/Question";
import { Tag } from "../../model/TagData";
import { IssueResult, IssueResultStatus } from "../../model/user/user_craft";
import { LogDebug } from "../../tools/log";
import { sleep } from "../../tools/time";
import { actionNextPage } from "../exam/action";
import {
    _actionAddQuestionUsedTime,
    _actionSetQuestionAnswer,
    _actionSetQuestionResult,
    actionSetExamResult,
} from "../exam/reducer";
import { selectSectionAction } from "../exam/selector";
import { AppThunk } from "../hooks";
import { RootState } from "../ReduxStore";
import { DisplayMode, actionUpdateTags } from "../root/reducer";
import { _actionSetSidebarQuestionAnswer } from "../search/reducer";
import { setQuestionData, setShowResult } from "./action_tool";
import { selectQuestion, selectQuestionAction, selectQuestionData } from "./selector";

export const actionSetShowResult = (b: boolean): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        setShowResult(dispatch, state, b);
    };
};

function updateIssueResult(
    iresult: IssueResult,
    sectionIndex: number,
    questionIndex: number,
    state: RootState,
    dispatch: any
) {
    if (state.displayMode === DisplayMode.SearchDispaly && state.searchRuntime.roomIn) {
        return;
    }
    const estate = state.examRuntime;
    const qresult = estate.exam.sections[sectionIndex].questions[questionIndex].result;
    if (state.displayMode === DisplayMode.ExamDispaly) {
        dispatch(
            _actionSetQuestionResult({
                si: sectionIndex,
                qi: questionIndex,
                result: { ...qresult, issue: iresult, correct: true },
            })
        );
    }
}

export const actionUpdateQuestionAnswer = (ans: Answer, noSaveBackend?: boolean): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        if (state.displayMode === DisplayMode.SearchDispaly && state.searchRuntime.roomIn) {
            return;
        }
        const estate = state.examRuntime;
        const sectionAction = selectSectionAction(state);
        const q = selectQuestion(state);
        const action = selectQuestionAction(state);
        if (state.displayMode === DisplayMode.ExamDispaly) {
            dispatch(_actionSetQuestionAnswer(ans));
        } else if (state.displayMode === DisplayMode.SearchDispaly) {
            dispatch(_actionSetSidebarQuestionAnswer(ans));
        }

        // 单词自动跳转下一题
        const question = selectQuestionData(state);
        if (question.category === QuestionCategory.Word) {
            await sleep(200);
            dispatch(actionNextPage());
        }

        if (!noSaveBackend) {
            methodUpdateQuestion(dispatch, {
                exam_id: estate.exam.id,
                section_index: estate.sectionIndex,
                question_index: q.index_key,
                action: { ...action, answer: ans, state: QuestionState.Answered },
                section_action: sectionAction,
            });
        }
    };
};

export const actionUpdateIssueResult = (
    sectionIndex: number,
    questionIndex: number,
    iresult: IssueResult,
    eresult: ExamResult
): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        if (state.displayMode === DisplayMode.SearchDispaly && state.searchRuntime.roomIn) {
            return;
        }
        const estate = state.examRuntime;
        const qresult = estate.exam.sections[sectionIndex].questions[questionIndex].result;
        if (state.displayMode === DisplayMode.ExamDispaly) {
            dispatch(
                _actionSetQuestionResult({
                    si: sectionIndex,
                    qi: questionIndex,
                    result: { ...qresult, issue: iresult },
                })
            );
            dispatch(actionSetExamResult(eresult));
        }
    };
};

export const actionSetPassage = (p: PassageData): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        dispatch(
            actionUpdateQuestionData(QuestionEditKind.Passage, (q: QuestionData) => {
                return { ...q, passage: p };
            })
        );
    };
};

export const actionSetInquiry = (i: InquiryData): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        dispatch(
            actionUpdateQuestionData(QuestionEditKind.Inquiry, (q: QuestionData) => {
                return { ...q, inquiry: i };
            })
        );
    };
};

export const actionSetInputMethod = (i: InputMethod): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        LogDebug("set input", i);
        dispatch(
            actionUpdateQuestionData(QuestionEditKind.Input, (q: QuestionData) => {
                return { ...q, input_method: i };
            })
        );
    };
};

export const actionSetAnalysis = (a: Analysis): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        dispatch(
            actionUpdateQuestionData(QuestionEditKind.Analysis, (q: QuestionData) => {
                return { ...q, analysis: a };
            })
        );
    };
};

export const actionSetStandardAnswer = (std_ans: string): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        dispatch(
            actionUpdateQuestionData(
                QuestionEditKind.StandardAnswer,
                (q: QuestionData) => {
                    return q;
                },
                () => {},
                { std_ans_text: std_ans } as QuestionEditExtraData
            )
        );
    };
};

export const actionSetManualMark = (m: ManualMark): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        dispatch(
            actionUpdateQuestionData(
                QuestionEditKind.Mark,
                (q: QuestionData) => {
                    return { ...q, manual_mark: m };
                },
                () => {
                    AlertSuccess("操作成功");
                }
            )
        );
    };
};

export const actionSetTags = (
    labels: string[],
    afterSuccess: () => void,
    editType?: number
): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        const q = selectQuestionData(state);
        UpdateQuestionTags({
            dataID: q.id,
            labels,
            editType: editType !== undefined ? editType : QuestionEditKind.Tag,
            afterSuccess: (tags: Tag[], d: QuestionData) => {
                dispatch(actionUpdateTags(tags));
                setQuestionData(d, state, dispatch);
                afterSuccess();
            },
            dispatch,
        });
    };
};

export const actionUpdateQuestionData = (
    editType: QuestionEditKind,
    updater: (q: QuestionData) => QuestionData,
    afterSuccess?: () => void,
    extra?: QuestionEditExtraData
): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        const q = selectQuestionData(state);
        const q2 = updater(q);
        methodEditQuestion(dispatch, {
            edit_type: editType,
            data_id: q2.id,
            data: q2,
            extra: extra ?? new QuestionEditExtraData(),
        }).then((rsp) => {
            setQuestionData(rsp.data, state, dispatch);
            if (afterSuccess) {
                afterSuccess();
            }
        });
    };
};

export const actionAddQuestionUsedTime = (t: number): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        if (state.displayMode !== DisplayMode.ExamDispaly) {
            return;
        }
        dispatch(_actionAddQuestionUsedTime(t));
    };
};

export const actionSaveCurrentIssue = (judge: boolean, afterSuccess: () => void): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();
        const estate = state.examRuntime;
        const sectionAction = selectSectionAction(state);
        const action = selectQuestionAction(state);
        const q = selectQuestion(state);
        const qd = selectQuestionData(state);
        if (qd.category !== QuestionCategory.Issue) {
            afterSuccess();
            return;
        }
        methodUpdateQuestion(dispatch, {
            exam_id: estate.exam.id,
            section_index: estate.sectionIndex,
            question_index: q.index_key,
            action: action,
            section_action: sectionAction,
        }).then(() => {
            if (judge) {
                dispatch(actionJudgeIssue(estate.exam.id, estate.sectionIndex, q.index_key));
            }
            afterSuccess();
        });
    };
};

export const actionJudgeIssue = (
    examID: string,
    sectionIndex: number,
    questionIndex: number
): AppThunk => {
    return async (dispatch: any, getState: () => RootState) => {
        const state = getState();

        let callCheckCount = 0;
        const quickCheckCount = (60 * 1) / 10;
        const maxCheckCount = quickCheckCount + (60 * 4) / 30;
        // 尝试5分钟，第1分钟每10s检查一次，后2分钟每30s检查一次
        const callCheckResult = (afterSuccess: (iresult: IssueResult) => void) => {
            callCheckCount++;
            LogDebug("CheckIssueResult round", callCheckCount);
            methodCheckIssueResult(dispatch, {
                exam_id: examID,
                section_index: sectionIndex,
                question_index: questionIndex,
            }).then((rsp) => {
                afterSuccess(rsp.issue_result);
            });
        };
        const afterCheckResult = async (iresult: IssueResult) => {
            LogDebug("check result", iresult);
            updateIssueResult(
                { ...iresult, progress: (99 / maxCheckCount) * callCheckCount },
                sectionIndex,
                questionIndex,
                state,
                dispatch
            );
            if (iresult.status !== IssueResultStatus.Judging) {
                return;
            }
            if (callCheckCount >= maxCheckCount) {
                iresult.status = IssueResultStatus.Failed;
                return;
            }
            if (callCheckCount >= quickCheckCount) {
                await sleep(30000);
            } else {
                await sleep(10000);
            }
            callCheckResult(afterCheckResult);
        };

        updateIssueResult(
            { status: IssueResultStatus.Judging, progress: 0 } as IssueResult,
            sectionIndex,
            questionIndex,
            state,
            dispatch
        );
        methodJudgeIssue(dispatch, {
            exam_id: examID,
            section_index: sectionIndex,
            question_index: questionIndex,
        }).then(() => {
            LogDebug("JudgeIssue success");
            sleep(5000).then(() => {
                callCheckResult(afterCheckResult);
            });
        });
    };
};
